import { motion } from "framer-motion"
import { useInView } from "react-intersection-observer"

const SystemDesign = () =>  {
    const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 })

    return (
        <div className="w-full mx-auto p-6 lg:px-12 lg:py-16 text-zinc-800 dark:text-zinc-200 text-sm" ref={ref}>
            <div className="grid lg:grid-cols-2 gap-12 items-center justify-between">

                <motion.div 
                    className="lg:w-10/12 space-y-6 lg:order-2"
                    initial={{ opacity: 0, x: 50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="flex flex-row text-zinc-800 dark:text-zinc-200 font-light items-center justify-between">
                        <div className="flex justify-start space-x-3 items-center">
                            <span className="text-purple-600 dark:text-purple-400 font-mono text-xl font-bold">03</span>
                            <span className="text-3xl lg:text-4xl font-bold text-zinc-900 dark:text-white">KMP Architecture Consulting</span>
                        </div>
                    </div>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        Sharing application logic across Android and iOS saves hundreds of engineering hours and keeps business rules synchronized. We architect resilient Kotlin Multiplatform (KMP) shared modules.
                    </p>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        By extracting API call definitions, offline data structures (SQLDelight), state machine workflows, and on-device ML model pipelines into a unified shared module, we deliver native UI responsiveness with shared logic efficiency.
                    </p>
                </motion.div>

                <motion.div 
                    className="mx-auto lg:w-9/12 w-full lg:order-1"
                    initial={{ opacity: 0, x: -50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="p-6 rounded-2xl border border-slate-200 dark:border-purple-500/20 bg-white dark:bg-[#202222] shadow-[0_4px_20px_rgba(0,0,0,0.03)] dark:shadow-[0_0_35px_rgba(168,85,247,0.08)] hover-glow transition-all duration-300">
                        <div className="grid grid-cols-2 gap-4 text-center text-[10px] font-mono mb-4">
                            <div className="p-2.5 rounded-lg border border-purple-200 dark:border-purple-500/20 bg-purple-100/50 dark:bg-purple-950/20 text-purple-700 dark:text-purple-300 font-semibold">
                                Jetpack Compose (Android)
                            </div>
                            <div className="p-2.5 rounded-lg border border-indigo-200 dark:border-indigo-500/20 bg-indigo-100/50 dark:bg-indigo-950/20 text-indigo-700 dark:text-indigo-300 font-semibold">
                                SwiftUI (iOS)
                            </div>
                        </div>
                        <div className="text-center text-purple-600 dark:text-purple-500 text-xs mb-4">↓ (Native UI Bindings)</div>
                        <div className="p-4 rounded-xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900/80 space-y-2">
                            <div className="text-[10px] font-semibold text-zinc-800 dark:text-zinc-300 font-mono text-center">SHARED KMP CORE MODULE</div>
                            <div className="grid grid-cols-3 gap-2 text-[9px] font-mono text-center pt-2">
                                <div className="p-1.5 rounded bg-white dark:bg-slate-950 border border-slate-200 dark:border-white/5 text-zinc-500 dark:text-slate-400 shadow-sm">Offline DB</div>
                                <div className="p-1.5 rounded bg-white dark:bg-slate-950 border border-slate-200 dark:border-white/5 text-zinc-500 dark:text-slate-400 shadow-sm">API Client</div>
                                <div className="p-1.5 rounded bg-white dark:bg-slate-950 border border-slate-200 dark:border-white/5 text-zinc-500 dark:text-slate-400 shadow-sm">AI Engine</div>
                            </div>
                        </div>
                    </div>
                </motion.div>

            </div>
        </div>
    )
}

export default SystemDesign